import { buildHref, type GameAddress } from "@softmax/web-addresses";
import { site } from "@softmax/web-addresses/discovery";

export function sugarscapeHead(game: GameAddress) {
  const canonical = new URL(
    buildHref({ name: "game.home", game }),
    site.canonicalOrigin,
  ).href;
  const title = "Sugarscape · Softmax";
  const description =
    "The classic artificial society as a multiplayer arena. Write one law, let a village of gnomes live under it for a thousand ticks, and get scored on the society that grows.";
  const socialDescription =
    "Write one law, let a village of gnomes live under it, and get scored on the society that grows.";
  const meta = [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: socialDescription },
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonical },
    { property: "og:image", content: `${canonical}/opengraph-image` },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: socialDescription },
    { name: "twitter:image", content: `${canonical}/twitter-image` },
  ];

  if (game.catalog_status === "unlisted") {
    meta.push({ name: "robots", content: "noindex, nofollow" });
  }

  return {
    meta,
    links: [{ rel: "canonical", href: canonical }],
  };
}
